<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">


      <div class="container" *ngIf="myForm">
        <div class="d-flex justify-content-center h-1001">
          <div class="card">
            <div class="row">
              <div class="col-md-12">
                <div class="card-body sign">
                  <form [formGroup]="myForm"
                    role="form"
                    #form="ngForm"
                    (ngSubmit)="submitForm(myForm)"
                  >
                  <h6>Load Details:</h6>
                  <br>
                    <div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="logon" >Log on </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="logon"
                          id="logon"
                          required="required"
                        />
                      </div>
                      <div class="col-md-4"  *ngIf="myForm.get('logon').invalid && (myForm.get('logon').dirty || myForm.get('logon').touched) || (myForm.get('logon').invalid && myForm.get('logon').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide valid logon </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="routeId" >Route Id </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="routeId"
                          id="routeId"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('routeId').invalid && (myForm.get('routeId').dirty || myForm.get('routeId').touched) || (myForm.get('routeId').invalid && myForm.get('routeId').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid routeId </span>
                      </div>


                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="billOfLading" >Bill of lading </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="billOfLading"
                          id="billOfLading"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('billOfLading').invalid && (myForm.get('billOfLading').dirty || myForm.get('billOfLading').touched) || (myForm.get('billOfLading').invalid && myForm.get('billOfLading').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide valid billOfLading </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="productId" >Product Id </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="productId"
                          id="productId"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('productId').invalid && (myForm.get('productId').dirty || myForm.get('productId').touched) || (myForm.get('productId').invalid && myForm.get('productId').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid productId </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="productName" >Product Name </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="productName"
                          id="productName"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('productName').invalid && (myForm.get('productName').dirty || myForm.get('productName').touched) || (myForm.get('productName').invalid && myForm.get('productName').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid productName </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="quantity" >Quantity </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="quantity"
                          id="quantity"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('quantity').invalid && (myForm.get('quantity').dirty || myForm.get('quantity').touched) || (myForm.get('quantity').invalid && myForm.get('quantity').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide valid product quantity </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="routeStatus" >Route Status </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="routeStatus"
                          id="routeStatus"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('routeStatus').invalid && (myForm.get('routeStatus').dirty || myForm.get('routeStatus').touched) || (myForm.get('routeStatus').invalid && myForm.get('routeStatus').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid routeStatus </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="scac" >Scac </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="scac"
                          id="scac"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('scac').invalid && (myForm.get('scac').dirty || myForm.get('scac').touched) || (myForm.get('scac').invalid && myForm.get('scac').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid scac </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="punchIn" >Punch In </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="punchIn"
                          id="punchIn"
                          required="required"
                        />


                      </div>
                      <div *ngIf="myForm.get('punchIn').invalid && (myForm.get('punchIn').dirty || myForm.get('punchIn').touched) || (myForm.get('punchIn').invalid && myForm.get('punchIn').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid punchIn date and time </span>
                      </div>

                      <div class="col-md-4" class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="punchOut" >Punch Out </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="punchOut"
                          id="punchOut"
                          required="required"
                        />


                      </div>
                      <div class="col-md-4" *ngIf="myForm.get('punchOut').invalid && (myForm.get('punchOut').dirty || myForm.get('punchOut').touched) || (myForm.get('punchOut').invalid && myForm.get('punchOut').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid punchOut date and time </span>
                      </div>

                      <div class="col-md-4 input-group form-group login_input">
                        <label class="join_label" for="date" >Date </label>

                        <input
                          type="text"
                          class="form-control login_txt"
                          formControlName="date"
                          id="date"
                          required="required"
                        />

                      </div>
                      <div class="col-md-4" *ngIf="myForm?.get('date')?.invalid && (myForm?.get('date')?.dirty || myForm.get('date').touched) || (myForm.get('date').invalid && myForm.get('date').untouched && isSubmitted)">
                        <span style="color:red;font-weight:bold"> Please provide a valid date </span>
                      </div>

                    </div>
                    <app-breaks [appleForm]="myForm"></app-breaks>
                    <div class="row">
                      <div class="form-group login_btn_out1">
                        <button type="submit" class="btn float-right login_btn" [disabled]="myForm.invalid">
                          SAVE
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
